<template>
  <v-app-bar :elevation="2" color="grey-darken-4">
    <v-app-bar-nav-icon
      variant="text"
      @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <v-toolbar-title>USE</v-toolbar-title>
    <v-spacer></v-spacer>
    <Link
      v-if="$page.props.auth.user"
      :href="$routes.destroy_user_session()"
      as="button"
      method="delete"
    >
      <v-btn variant="tonal" color="blue" class="text-white" :elevation="3"
        >Logout</v-btn
      ></Link
    >
    <v-btn
      v-else
      :href="$routes.new_user_session()"
      variant="tonal"
      color="blue"
      class="text-white"
      :elevation="3"
      >Login</v-btn
    >
  </v-app-bar>
  <v-navigation-drawer v-model="drawer" temporary>
    <v-list class="text-center">
      <v-list-item class="my-1">
        <v-btn :href="$routes.root()" variant="text">Home</v-btn>
      </v-list-item>
      <v-list-item class="my-1">
        <v-btn :href="$routes.projects()" variant="text">Projects</v-btn>
      </v-list-item>
      <v-list-item class="my-1">
        <v-btn :href="$routes.user_manual()" variant="text">Manual</v-btn>
      </v-list-item>
    </v-list>
    <div
        v-if="loggedInUser && userEmail.includes('response')"
      style="
        position: fixed;
        bottom: 0px;
        display: flex;
        justify-content: center;
        text-align: center;
      "
    >
      <img
        src="@assets/images/logos/response.png"
        alt="cperi"
        class="ml-6"
        style="width: 200px"
      />
    </div>
  </v-navigation-drawer>
</template>

<script setup>
import {computed, ref} from "vue";
import {Link, usePage} from "@inertiajs/vue3";
const drawer = ref(null);
const page = usePage();

// TODO: Copied from Main.vue. Remove code duplication.
const userEmail = computed(() => {
  return page.props.auth.user.email
})

const loggedInUser = computed(() => {
  return page.props.auth.user !== null
})
</script>

<style></style>
